import { icon } from "@msuite/ui/icons";
import type { MenuItems } from "@msuite/ui/menu";
import { createColumnMenuOptions } from "@msuite/ui/table";
import { uniqueArray } from "@msuite/utils/array";

export const createTypeMenuOptions = createColumnMenuOptions(({ table, columnId }) => {
	const columnValues = uniqueArray(
		table.getCoreRowModel().rows.map((row) => row.getValue(columnId) as string),
	);
	const menuItems: MenuItems = [
		"divider",
		{
			icon: icon("Filter"),
			label: "All",
			onClick: () => {
				table.getColumn(columnId)?.setFilterValue(undefined);
			},
			isActive: table.getColumn(columnId)?.getFilterValue() === undefined,
		},
		...columnValues.map((value) => ({
			label: value,
			icon: icon("Filter"),
			onClick: () => {
				table.getColumn(columnId)?.setFilterValue(value);
			},
			isActive: table.getColumn(columnId)?.getFilterValue() === value,
		})),
	];
	return menuItems;
});
